import type { FormState, ServiceKey } from "./types";

export class ServiceActiveMapper {
  active(form: FormState, key: ServiceKey): boolean {
    switch (key) {
      case "adr":
        return form.adr.active;
      case "temp":
        return form.temp.active;
      case "tail":
        return form.tail.active;
      case "ftl":
        return form.ftl.active;
      case "time":
        return form.time.active;
      case "ref":
        return form.ref.active;
      case "attachments":
        return form.attachments.active;
    }
  }
}

export class ServiceSelectionMapper {
  update(form: FormState, key: ServiceKey, active: boolean): FormState {
    switch (key) {
      case "adr":
        return {
          ...form,
          adr: active ? { ...form.adr, active: true } : { active: false, adrClass: "", un: "" },
        };
      case "temp":
        return {
          ...form,
          temp: active ? { ...form.temp, active: true } : { active: false, min: "", max: "" },
        };
      case "tail":
        return {
          ...form,
          tail: active
            ? { ...form.tail, active: true }
            : { active: false, load: false, unload: false },
        };
      case "ftl":
        return {
          ...form,
          ftl: active ? { ...form.ftl, active: true } : { active: false },
        };
      case "time":
        return {
          ...form,
          time: active
            ? { ...form.time, active: true }
            : {
                active: false,
                deliveryDate: "",
                loadType: "window",
                loadFrom: "",
                loadUntil: "",
                loadFixed: "",
                unloadType: "window",
                unloadFrom: "",
                unloadUntil: "",
                unloadFixed: "",
              },
        };
      case "ref":
        return {
          ...form,
          ref: active
            ? { ...form.ref, active: true }
            : { active: false, reference: "", loadReference: "", unloadReference: "", notes: "" },
        };
      case "attachments":
        return {
          ...form,
          attachments: active
            ? { ...form.attachments, active: true }
            : { active: false, files: [] },
        };
    }
  }
}
